import { Injectable } from '@angular/core';
import { QuizQuestionHeadingApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class QuizQuestionHeadingsService extends CrudService<QuizQuestionHeadingApiModel, number> {
  public apiUrl = 'quiz-question-headings';
}
